import React from "react";

export default function Footer() {
  return (
    <div className="control_footer">
      <p>
        本頁面資訊每十分鐘會更新一次，若要取得即時資訊請點擊該設備右方按鈕，立即取得新資料。
      </p>
      <p>按鈕上文字顯示為“未知”代表設備未開機或不在電信服務範圍內。</p>
    </div>
  );
}
